/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MoreSchedulingOptions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import HideAction from './HideAction/index'
import No from './No/index'
import React from 'react'
import ShowAction from './ShowAction/index'



/** @type {import('Simple/types.js').View} */
export default function MoreSchedulingOptions({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/Existing/Content/MoreSchedulingOptions"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let displayPatientOptionsValueData = fromData.useDataFormat({ viewPath,
context: 'display_patient_options',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: displayPatientOptionsValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ShowAction'}>
<ShowAction
  viewPath={`${viewPath}/ShowAction`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'HideAction'}>
<HideAction
  viewPath={`${viewPath}/HideAction`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}